import type { ReactElement } from 'react';
import { SelectFilterChip } from 'components/filters/SelectFilterChip';
import { useScopedActivityTypeOptions } from './useScopedActivityTypeOptions';

export function TypeFilterChip({ global, label }: { global: boolean; label?: string }): ReactElement {
  const typeOptions = useScopedActivityTypeOptions(global);
  return <SelectFilterChip name="type" label={label} options={typeOptions} isMulti defaultValueLabel="All types" />;
}
